import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import packageJson from '../../../package.json';


export function* initBandwidthSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const days = action.days ? action.days : 7;
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  // console.log('TOKENEEE', token, sessionToken)
  if (sessionToken) {
    yield put(actions.initBandwidthStart(days));
    try {
      let response = {};

      response = yield axios.post(
        '/bandwidth',
        {
          rMac: rMac || '',
          days: days,
          bToken: sessionToken,
          sessionToken:sessionToken
        }
      )

      yield put(actions.setBandwidth(response.data.bandwidth));//COMMENT THIS IN IF TESTING SERVER
    } catch (error) {
      yield put(actions.fetchBandwidthFailed());
    }
  } else {
    // console.log('NO TOKEN')
  }

}



